import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch } from 'react-redux';
import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";
import FusePageSimple from "../../../@fuse/core/FusePageSimple";
import FormReport from "./form_report";
import ResultSearch from "./result_search";
import { getNotifications } from '../../theme-layouts/shared-components/notificationPanel/store/dataSlice';
import { getKeycloakRole } from '../../shared-components/utils';


const Root = styled(FusePageSimple)(({ theme }) => ({
  "& .FusePageSimple-header": {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
  },
  "& .FusePageSimple-toolbar": {},
  "& .FusePageSimple-content": {},
  "& .FusePageSimple-sidebarHeader": {},
  "& .FusePageSimple-sidebarContent": {},
}));

function Reportes(props) {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const roleKeycloak = getKeycloakRole(keycloak?.realmAccess?.roles);

  const id = keycloak?.tokenParsed?.sub;
  const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];

  const [initDateSelected, setInitDateSelected] = useState(null);
  const [endDateSelected, setEndDateSelected] = useState(null);

  const filterProps = {
    initDateSelected,
    setInitDateSelected,
    endDateSelected,
    setEndDateSelected,
  };

  useEffect(() => {
    dispatch(getNotifications({ idUser: id, roleId }));
  }, []);

  return (
    <>
      {['NOC', "Administrador", "Usuario", "Monitoreo"].includes(roleKeycloak) && (
        <Root
          content={
            <div className="w-full p-24">
              <FormReport {...filterProps} />
              <ResultSearch {...filterProps} />
            </div>
          }
          scroll="content"
        />
      )}
    </>
  );
}

export default Reportes;

